import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import {
  openChat as openChatAction,
  selectChat,
  selectCurrentThreadId,
  useAppDispatch,
  useGetThreadQuery,
} from '@fly/store';

import { useChatCore } from './useChatCore';

export const useChatActions = (): {
  sendMessage: (message: string, display?: boolean) => void;
  openChat: () => void;
  isStreaming: boolean;
} => {
  const dispatch = useAppDispatch();

  const currentThreadId = useSelector(selectCurrentThreadId);
  const { data: fetchedThread = null } = useGetThreadQuery(currentThreadId!, {
    skip: !currentThreadId,
  });

  const currentThread =
    currentThreadId && fetchedThread?.thread_id === currentThreadId
      ? fetchedThread
      : null;

  const { sendMessage } = useChatCore(currentThread);
  const chat = useSelector(selectChat);

  const openChat = useCallback(() => {
    dispatch(openChatAction(true));
  }, [dispatch]);

  return {
    sendMessage,
    openChat,
    isStreaming: chat.isStreaming,
  };
};
